import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { FiChevronDown, FiEdit, FiPlusSquare, FiShare, FiTrash } from 'react-icons/fi';
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const MenuItem = ({ title = "", Icon, submenus = [], link = "", notification = false, menuOpen, collapsed = false }) => {
    const location = useLocation();
    const [open, setOpen] = useState();
    const hasNotification = typeof notification === 'number' && notification > 0;

    useEffect(() => {
        setOpen(submenus.length && location.pathname.split("/").includes(link))
    }, [])

    return (
        <motion.div animate={open ? "open" : "closed"} className={`relative w-full`}>
            <button
                onClick={() => { setOpen((pv) => !pv); menuOpen() }}
                className={`w-full rounded flex ${location.pathname === link ? 'bg-nt-blue text-white pointer-events-none' : ''}`}
            >
                <Link
                    className={`no-underline p-2 h-full w-full items-center flex flex-row text-nt-blue group-hover:text-white relative
                        ${collapsed ? 'gap-0 md:justify-center xl:justify-start xl:gap-3' : 'gap-3'}
                        ${location.pathname === link ? ' text-white' : ''}`}
                    to={link}
                    title={collapsed ? title : undefined}
                >
                    <span className="relative shrink-0">
                        <Icon />
                        {collapsed && hasNotification ? (
                            <span className="hidden md:block xl:hidden absolute -top-0.5 -right-0.5 w-2 h-2 bg-nt-red rounded-full" />
                        ) : null}
                    </span>
                    <p className={`flex-1 text-left font-medium ${collapsed ? 'hidden xl:block' : 'block'}`}>
                        {submenus.length ? title : title}
                        {submenus.length > 0 && <motion.span variants={iconVariants} className="ml-auto">
                            <FiChevronDown />
                        </motion.span>}
                    </p>
                    {hasNotification ? (
                        <span className={`shrink-0 bg-nt-red text-white text-xs font-semibold rounded-full min-w-[1.5rem] h-6 px-1.5 items-center justify-center ${collapsed ? 'hidden xl:flex' : 'flex'}`}>
                            {notification > 99 ? '99+' : notification}
                        </span>
                    ) : null}
                </Link>
            </button>

            <motion.ul
                initial={wrapperVariants.closed}
                variants={wrapperVariants}
                className="flex flex-col m-0 ml-[30px] text-nt-blue"
            >
                {submenus.map((menu, i) => {
                    return (<Option key={i} text={menu.text} link={menu.link} location={location} />)
                })}
            </motion.ul>
        </motion.div>
    )
}

const Option = ({ text, link, location }) => {
    return (
        <motion.li
            variants={itemVariants}
            className={`w-full cursor-pointer flex items-center rounded px-2 py-2 mb-1 ${location.pathname === link ? 'bg-nt-blue text-white pointer-events-none' : 'hover:bg-nt-red hover:text-white'}`}
        >
            {/* <motion.span variants={actionIconVariants}>
                <Icon />
            </motion.span> */}
            <Link className={`no-underline w-full rounded block mb-0 ${location.pathname === link ? 'text-white' : 'text-nt-blue'}`} to={link}><span>{text}</span></Link>

        </motion.li>
    );
};
const wrapperVariants = {
    open: {
        scaleY: 1,
        transition: {
            when: "beforeChildren",
        },
        height: "auto",
    },
    closed: {
        scaleY: 0,
        transition: {
            when: "afterChildren",
        },
        height: 0,
    },
};

const iconVariants = {
    open: { rotate: 180 },
    closed: { rotate: 0 },
};

const itemVariants = {
    open: {
        opacity: 1,
        y: 0,
        transition: {
            when: "beforeChildren",
        },
    },
    closed: {
        opacity: 0,
        y: -5,
        transition: {
            when: "afterChildren",
        },
    },
};

export { MenuItem }